document.addEventListener('DOMContentLoaded', function () {
    RSSSubscribe();
});

function RSSSubscribe() {
    const rssFeedElement = document.getElementById('rss-feed');
    const tooltipElement = document.getElementById('tooltip');

    if (rssFeedElement) {
        rssFeedElement.addEventListener('click', function () {
            const url = window.location.href + 'feed';
            navigator.clipboard.writeText(url).then(function () {
                tooltipElement.style.display = 'flex';

                setTimeout(function () {
                    tooltipElement.style.display = 'none';
                }, 2000);
            }).catch(function (err) {
                console.log('Error: ', err);
            });
        });
    }
}
